(ns ycweb.app.admin.tech.services.cronscheduler.dashboard
  (:require
   #?@(:clj
       [[clj-time.core :as dt]
        [clj-time.coerce :as dtc]]
       :cljs
       [[cljs-time.core :as dt]
        [cljs-time.coerce :as dtc]])
   [clojure.string :as str]
   [rum.core :as rum]
   [ycweb.app.dashboard.common :as dcommon]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.components.common :as cmn]
   [ycweb.components.editor.base :as editor]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

(defmethod comms/receive :admin.cronscheduler/cron.execute [app-atom {:keys [cron]}]
  (let [process-atom (cmn/process-cursor app-atom)
        now (dt/now)]
    (toaster/close-overlay app-atom :admin.cronscheduler/cron-execution)
    (swap! process-atom update-in [:crons (:cron/job-name cron) :cron/job-data :cron/responses]
      (fn [responses]
        (let [updated-responses
              (cond
                (or
                  (nil? responses)
                  (empty? responses))
                [{:cron/response-time now
                  :cron/response-unixtime (ud/php-timestamp now)
                  :cron/job-response (:cron/job-response cron)}]

                :else
                (conj responses
                  {:cron/response-time now
                   :cron/response-unixtime (ud/php-timestamp now)
                   :cron/job-response (:cron/job-response cron)}))]
          (sort-by :cron/response-unixtime u/desc updated-responses))))))

(defmethod comms/receive :admin.cronscheduler/consumer.logs [app-atom {:keys [consumer-logs]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (toaster/close-overlay app-atom :admin.cronscheduler/consumer-logs)
    (swap! process-atom assoc :consumer-logs consumer-logs)))

(defn fetch-consumer-logs [app-atom cron-log-uuid]
  (toaster/open-overlay app-atom :admin.cronscheduler/consumer-logs)
  (comms/send :admin.cronscheduler/consumer.logs
    {:cron-log-uuid cron-log-uuid}))

(defmethod grid/action :admin.cronscheduler/execute-cron-job [app-atom {:cron/keys [job-name]} _]
  (let [process-atom (cmn/process-cursor app-atom)
        {:cron/keys [job-group]} (cmn/curact process-atom [:crons job-name])
        editor-atom (editor/editor-cursor app-atom :cron-executor)
        form (cmn/curact editor-atom :form)
        inputs
        (reduce
          (fn [acc [k v]]
            (assoc acc k (:value v)))
          {} form)]
    (toaster/open-overlay app-atom :admin.cronscheduler/cron-execution)

    (comms/send :admin.cronscheduler/cron.execute
      {:cron/job-name job-name
       :cron/job-group job-group
       :cron/inputs inputs})))

(rum/defc job-response-feedback < rum/reactive cmn/cursors
  [{:cron/keys [response-time job-response] :as response-feedback}]
  (let [{:keys [success msg]} job-response]
    [:div
     (ud/format-date response-time "d MMMM yyyy HH:mm:ss")
     (cond
       success
       (feedback/feedback :success "Job Executed!"
         [[:div
           [:b "Message: "] msg]
          [:div
           (when (u/presence (:datadog/link job-response))
             [:a
              {:href (:datadog/link job-response)
               :target "_blank"
               :class (u/bem :button [:text-link :text-default])}
              "Namespace logs on Datadog"])]])

       :else
       (feedback/feedback :error "Job Failed"
         [[:div
           [:b "Message: "] msg]
          [:div
           (when (u/presence (:datadog/link job-response))
             [:a
              {:href (:datadog/link job-response)
               :target "_blank"
               :class (u/bem :button [:text-link :text-default])}
              "Stack trace on Datadog"])]]))]))

(rum/defc cron-job-modal-body < rum/reactive cmn/cursors [app-atom modal-atom m-config]
  (let [process-atom (cmn/process-cursor app-atom)
        job-name (cmn/curact modal-atom :cron/job-name)
        job-data (cmn/curact process-atom [:crons job-name :cron/job-data])
        cron-inputs (cmn/curact modal-atom :cron/inputs)
        editor-fields
        (map
          (fn [[k v]]
            {:name k
             :label (name k)
             :type v})
          cron-inputs)]
    [:div
     (headings/heading job-name
       {:type :h4
        :size :medium
        :subtext ""})
     [:div
      [:hr]
      (feedback/feedback :warning "Warning! *Update*"
        [:ul
         [:li "This feature will execute the job on the CRON profile via an RPC call"]
         [:li "If there's an INPUT shape for the cron, input params will show here (as string inputs for now)."]
         [:li "For example a date (4th of December 2024) can be coerced correctly with the following formats:"]
         [:ul
          [:li "'12/04/2024'"]
          [:li "'2024-12-04 02:00:00'"]]])
      (headings/heading "Inputs"
        {:type :h6
         :size :small
         :subtext ""})
      (into
        [:form.u-max-width-480.u-block-center]
        (map
          (fn [editor-field]
            (editor/build-input-field app-atom
              {:editor-name :cron-executor}
              editor-field))
          editor-fields))]
     [:hr]
     [:div
      (headings/heading "Job response"
        {:type :h4
         :size :small
         :subtext "This is the response that would have been given by the executed function"})
      (into
        [:div]
        (map #(job-response-feedback %) (:cron/responses job-data)))
      (toaster/loading-overlay app-atom :admin.cronscheduler/cron-execution)]
     (toaster/loading-overlay app-atom :admin.cronscheduler/cron-job)]))

(rum/defc cron-job-modal-footer [app-atom modal-atom _]
  (let [job-name (cmn/curact modal-atom :cron/job-name)]
    (grid/button-row
      {:left-text "Close"
       :left-no-icon true
       :left-fn #(grid/dispatch-modal-action app-atom :admin.cronscheduler/close-cron-job {})
       :right-text "Execute"
       :right-no-icon true
       :right-fn
       #(grid/dispatch-modal-action app-atom :admin.cronscheduler/execute-cron-job
          {:cron/job-name job-name} {:prevent-closing true})})))

(defmethod grid/modal-config :admin.cronscheduler/cron-job [app-atom config _]
  {:body cron-job-modal-body
   :footer cron-job-modal-footer
   :cancel-key :admin.cronscheduler/close-cron-job
   :layout :modal
   :modal-type :details
   :max-width 920})

(defn row-colour [status]
  (cond
    ;; Manual executions - light blue
    (and status (str/starts-with? status "Manual: ")) "#add8e6"
    (contains? #{"Missed" "Exception"} status) "#f18d8b"
    (contains? #{"Cancelled"} status) "#f39b5d"
    (contains? #{"Misfire" "Skipped"} status) "#ffda6a"
    :else "white"))

(defn format-date-or-na [value fmt]
  (if value
    (ud/format-date value fmt)
    "N/A"))

(rum/defc table-row-log [row]
  [:tr
   {:style
    {:background-color (row-colour (or (:display-status row) (:status row)))}}
   [:td
    {:style
     {:padding "10px 6px"
      :border "1px solid #000"
      :text-align "center"}}
    (format-date-or-na (:datescheduled row) "dd/MM/yyyy HH:mm:ss")]
   [:td
    {:style
     {:padding "10px 6px"
      :border "1px solid #000"
      :text-align "center"}}
    (format-date-or-na (:datestarted row) "dd HH:mm:ss")]
   [:td
    {:style
     {:padding "10px 6px"
      :border "1px solid #000"
      :text-align "center"}}
    (format-date-or-na (:datefinished row) "dd HH:mm:ss")]
   [:td
    {:style
     {:padding "10px 6px"
      :border "1px solid #000"
      :text-align "center"}}
    (or (:display-status row) (:status row))]
   [:td
    {:style
     {:padding "10px 6px"
      :border "1px solid #000"
      :text-align "left"}}
    (:message row)]])

;; Consumer log status colors
(defn consumer-status-colour [status]
  (cond
    (= status "Exception") "#f18d8b"
    (= status "Timeout") "#f39b5d"
    (= status "Running") "#87ceeb"
    (= status "Finished") "#90EE90"
    :else "white"))

(rum/defc table-row-consumer-log [log]
  [:tr
   {:style {:background-color (consumer-status-colour (:status log))}}
   [:td {:style {:padding "6px" :border "1px solid #ddd" :text-align "center"}}
    (or (:sequence-number log) "-")]
   [:td {:style {:padding "6px" :border "1px solid #ddd" :text-align "left"}}
    (:entity-identifier log)]
   [:td {:style {:padding "6px" :border "1px solid #ddd" :text-align "center"}}
    (:status log)]
   [:td {:style {:padding "6px" :border "1px solid #ddd" :text-align "center"}}
    (cond
      (:duration-seconds log)
      (str (:duration-seconds log) "s")
      :else "-")]
   [:td {:style {:padding "6px" :border "1px solid #ddd" :text-align "left"
                 :max-width "200px" :overflow "hidden" :text-overflow "ellipsis"}}
    (:message log)]])

(rum/defc consumer-logs-section < rum/reactive cmn/cursors [app-atom consumer-logs]
  (let [{:keys [logs summary total]} consumer-logs
        finished-count (get-in summary ["Finished" :count] 0)
        exception-count (get-in summary ["Exception" :count] 0)
        timeout-count (get-in summary ["Timeout" :count] 0)
        running-count (get-in summary ["Running" :count] 0)]
    [:div {:style {:margin-top "16px"}}
     (headings/heading "Consumer Logs" {:type :h4 :size :small :flush true})
     [:div {:style {:margin-bottom "8px" :font-size "13px"}}
      [:span {:style {:margin-right "16px"}}
       [:b "Total: "] total]
      [:span {:style {:margin-right "16px" :color "#27ae60"}}
       [:b "Finished: "] finished-count]
      (when (> exception-count 0)
        [:span {:style {:margin-right "16px" :color "#c0392b"}}
         [:b "Exceptions: "] exception-count])
      (when (> timeout-count 0)
        [:span {:style {:margin-right "16px" :color "#d35400"}}
         [:b "Timeouts: "] timeout-count])
      (when (> running-count 0)
        [:span {:style {:margin-right "16px" :color "#2980b9"}}
         [:b "Running: "] running-count])]
     (cond
       (and logs (not (empty? logs)))
       [:table {:class (u/bem :oTable [:has-shadow])
                :style {:font-size "12px"}}
        [:thead
         [:tr
          [:th.u-text-center {:style {:width "40px"}} "#"]
          [:th.u-text-left "Entity"]
          [:th.u-text-center "Status"]
          [:th.u-text-center "Duration"]
          [:th.u-text-left "Message"]]]
        (into [:tbody]
          (->> logs
            (map table-row-consumer-log)))]

       :else
       [:div {:style {:padding "12px" :color "#666"}}
        "No consumer logs for this execution."])
     (toaster/loading-overlay app-atom :admin.cronscheduler/consumer-logs)]))

(defn trend-row-colour [trend-row]
  (cond
    (> (:exception-count trend-row) 0) "#f18d8b"
    (> (:misfire-count trend-row) 0) "#ffda6a"
    :else "white"))

(rum/defc table-row-trend [trend-row]
  [:tr
   {:style {:background-color (trend-row-colour trend-row)}}
   [:td {:style {:padding "6px" :border "1px solid #ddd" :text-align "center"}}
    (ud/format-date (:date-from trend-row) "dd/MM")]
   [:td {:style {:padding "6px" :border "1px solid #ddd" :text-align "center"}}
    (:expected-count trend-row)]
   [:td {:style {:padding "6px" :border "1px solid #ddd" :text-align "center"}}
    (:actual-count trend-row)]
   [:td {:style {:padding "6px" :border "1px solid #ddd" :text-align "center"}}
    (:finished-count trend-row)]
   [:td {:style {:padding "6px" :border "1px solid #ddd" :text-align "center"
                 :color (if (> (:exception-count trend-row) 0) "#c0392b" "inherit")
                 :font-weight (if (> (:exception-count trend-row) 0) "bold" "normal")}}
    (:exception-count trend-row)]
   [:td {:style {:padding "6px" :border "1px solid #ddd" :text-align "center"
                 :color (if (> (:misfire-count trend-row) 0) "#d35400" "inherit")
                 :font-weight (if (> (:misfire-count trend-row) 0) "bold" "normal")}}
    (:misfire-count trend-row)]
   [:td {:style {:padding "6px" :border "1px solid #ddd" :text-align "center"}}
    (cond
      (:avg-time-seconds trend-row)
      (str (.toFixed (:avg-time-seconds trend-row) 1) "s")
      :else "N/A")]])

(rum/defc cron-modal-body < rum/reactive cmn/cursors [app-atom modal-atom m-config]
  (let [process-atom (cmn/process-cursor app-atom)
        job-name (cmn/curact modal-atom :cron/job-name)
        cron (cmn/curact process-atom [:crons job-name])
        {:cron/keys [summary logs scheduled-from scheduled-to]}
        (:cron/health cron)
        trend-data (:cron/trend cron)
        consumer-logs (cmn/curact process-atom :consumer-logs)
        ;; Get the most recent finished log entry with a uuid for consumer log lookup
        recent-log-with-uuid (first (filter :uuid logs))]
    [:div
     (headings/heading job-name
       {:type :h4
        :size :medium
        :subtext
        (str
          "From: " (ud/format-date scheduled-from "dd/MM/yyyy HH:mm")
          " - "
          "To: " (ud/format-date scheduled-to "dd/MM/yyyy HH:mm a"))})
     [:div
      (headings/heading "Summary" {:type :h4 :size :small :flush true})
      [:div
       {:class (u/bem :flex-grid-group [:flush-force :align-left])}
       [:div
        {:class (u/bem :flex-grid-block [:m-1-3])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Expected Count:"]
          (:expected-count summary)]]]
       [:div
        {:class (u/bem :flex-grid-block [:m-1-3])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Actual Count:"]
          (:actual-count summary)]]]
       [:div
        {:class (u/bem :flex-grid-block [:m-1-3])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Missing Count:"]
          (:missing-count summary)]]]]]
     [:hr]
     [:div
      (headings/heading "Actual Summary" {:type :h4 :size :small :flush true})
      [:div
       {:class (u/bem :flex-grid-group [:flush-force :align-left])}
       [:div
        {:class (u/bem :flex-grid-block [:m-1-3])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Started Count:"]
          (:started-count summary)]]]
       [:div
        {:class (u/bem :flex-grid-block [:m-1-3])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Finished Count:"]
          (:finished-count summary)]]]
       [:div
        {:class (u/bem :flex-grid-block [:m-1-3])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Unfinished Count:"]
          (:unfinished-count summary)]]]]
      ;;Time stats
      [:div
       {:class (u/bem :flex-grid-group [:flush-force :align-left])}
       [:div
        {:class (u/bem :flex-grid-block [:m-1-3])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Max time (seconds):"]
          (:max-time summary)]]]
       [:div
        {:class (u/bem :flex-grid-block [:m-1-3])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Min time (seconds):"]
          (:min-time summary)]]]
       [:div
        {:class (u/bem :flex-grid-block [:m-1-3])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Average time (seconds):"]
          (:avg-time summary)]]]]
      ;;Additional stats
      [:div
       {:class (u/bem :flex-grid-group [:flush-force :align-left])}
       [:div
        {:class (u/bem :flex-grid-block [:m-1-2])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Finished with the message 'No Message' Count:"]
          (:nomsgfin-count summary)]]]
       [:div
        {:class (u/bem :flex-grid-block [:m-1-2])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Unfinished (Excluding exceptions):"]
          (:unfinished-nonexception-count-perc summary) "%"]]]]
      ;;Status Counts
      [:div
       {:class (u/bem :flex-grid-group [:flush-force :align-left])}
       [:div
        {:class (u/bem :flex-grid-block [:m-1-5])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Cancelled:"]
          (:cancelled-count summary) " (" (:cancelled-perc summary) "%)"]]]
       [:div
        {:class (u/bem :flex-grid-block [:m-1-5])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Skipped:"]
          (:skipped-count summary) " (" (:skipped-perc summary) "%)"]]]
       [:div
        {:class (u/bem :flex-grid-block [:m-1-5])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Misfire:"]
          (:misfire-count summary) " (" (:misfire-perc summary) "%)"]]]
       [:div
        {:class (u/bem :flex-grid-block [:m-1-5])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Exception:"]
          (:exception-count summary) " (" (:exception-perc summary) "%)"]]]
       [:div
        {:class (u/bem :flex-grid-block [:m-1-5])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Network:"]
          (:network-failed-count summary) " (" (:network-failed-countperc summary) "%)"]]]]]
     [:hr]
     [:div
      (headings/heading "Missing Summary" {:type :h4 :size :small :flush true})
      [:div
       {:class (u/bem :flex-grid-group [:flush-force :align-left])}
       [:div
        {:class (u/bem :flex-grid-block [:m-1-3])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Missing Count:"]
          (:missing-count summary) " (" (:missing-perc summary) "%)"]]]
       ;;
       [:div
        {:class (u/bem :flex-grid-block [:m-1-3])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "First:"]
          (:first-missing summary)]]]
       ;;
       [:div
        {:class (u/bem :flex-grid-block [:m-1-3])}
        [:div.flex-grid-content
         [:span
          [:b {:style {:padding-right "10px"}} "Last:"]
          (:last-missing summary)]]]]]

     [:table {:class (u/bem :oTable [:has-shadow])}
      [:thead
       [:tr
        [:th.u-text-center "Date Scheduled"]
        [:th.u-text-center "Time Started"]
        [:th.u-text-center "Time Finished"]
        [:th.u-text-center "Status"]
        [:th.u-text-center "Message"]]]
      (into
        [:tbody]
        (->>
          logs
          (map #(table-row-log %))))]

     ;; 30-Day Trend Section
     [:hr]
     [:div.u-relative
      (headings/heading "30-Day Trend" {:type :h4 :size :small :flush true})
      (cond
        (and trend-data (not (empty? trend-data)))
        [:table {:class (u/bem :oTable [:has-shadow])
                 :style {:font-size "12px"}}
         [:thead
          [:tr
           [:th.u-text-center "Date"]
           [:th.u-text-center "Expected"]
           [:th.u-text-center "Actual"]
           [:th.u-text-center "Finished"]
           [:th.u-text-center "Exceptions"]
           [:th.u-text-center "Misfires"]
           [:th.u-text-center "Avg Time"]]]
         (into
           [:tbody]
           (->> trend-data
             (take 14)
             (map #(table-row-trend %))))]

        :else
        [:div {:style {:padding "12px" :color "#666"}}
         "No trend data available yet. Trend data is aggregated daily."])
      (toaster/loading-overlay app-atom :admin.cronscheduler/cron-trend)]

     ;; Consumer Logs Section
     [:hr]
     [:div.u-relative
      [:div {:style {:margin-bottom "12px"}}
       (cond
         recent-log-with-uuid
         [:button
          {:class (u/bem :button [:small :primary])
           :on-click #(fetch-consumer-logs app-atom (:uuid recent-log-with-uuid))}
          "Load Consumer Logs for Most Recent Execution"]

         :else
         [:span {:style {:color "#666" :font-size "13px"}}
          "No recent executions with UUID available."])]
      (when consumer-logs
        (consumer-logs-section app-atom consumer-logs))
      (toaster/loading-overlay app-atom :admin.cronscheduler/consumer-logs)]
     (toaster/loading-overlay app-atom :admin.cronscheduler/cron-log)]))

(defmethod grid/modal-config :admin.cronscheduler/cron-log [app-atom config _]
  {:body cron-modal-body
   :cancel-key :admin.cronscheduler/close-cron-log
   :layout :modal
   :modal-type :details
   :max-width 920})

(defn table-cell-to-date [value date-format]
  (cond
    value
    (ud/format-date value date-format)

    :else
    "N/A"))

(defn cron-summary-data [logs]
  (let [total-count (count logs)
        [missed-logs actual-logs] (u/separate #(= (:status %) "Missed") logs)
        sorted-missed-logs (sort-by :datescheduled missed-logs)
        missing-count (count missed-logs)
        actual-count (count actual-logs)
        started-count (count (filter #(u/presence (:datestarted %)) actual-logs))
        finished-logs (filter #(and (u/presence (:datestarted %))
                                 (u/presence (:datefinished %))) actual-logs)
        finished-count (count finished-logs)
        timed-logs
        (map
          (fn [finished-log]
            (let [seconds
                  (dt/in-seconds
                    (dt/interval
                      (:datestarted finished-log)
                      (:datefinished finished-log)))]
              (assoc finished-log :seconds-taken seconds)))
          finished-logs)
        times (seq (map :seconds-taken timed-logs))
        ;; Only calculate times if we have finished logs
        max-time (when times (apply max times))
        min-time (when times (apply min times))
        avg-time (when times (u/avg times))
        nomsgfin-count
        (count
          (filter
            (fn [log]
              (and
                (= (:status log) "Finished")
                (= (:message log) "No Message")))
            actual-logs))
        unfinished-count (- actual-count finished-count)
        ;; Percentages for statuses are calculated against actual-count (logs that ran)
        cancelled-count (count (filter #(= (:status %) "Cancelled") actual-logs))
        cancelled-perc (if (pos? actual-count) (int (* (/ cancelled-count actual-count) 100)) 0)
        skipped-count (count (filter #(= (:status %) "Skipped") actual-logs))
        skipped-perc (if (pos? actual-count) (int (* (/ skipped-count actual-count) 100)) 0)
        misfire-count (count (filter #(= (:status %) "Misfire") actual-logs))
        misfire-perc (if (pos? actual-count) (int (* (/ misfire-count actual-count) 100)) 0)
        ;; Missing percentage is calculated against total expected (total-count)
        missing-perc (if (pos? total-count) (int (* (/ missing-count total-count) 100)) 0)
        unfinished-nonexception-count
        (count
          (filter
            (fn [log]
              (and
                (not= (:status log) "Exception")
                (nil? (:datefinished log))))
            actual-logs))
        unfinished-nonexception-count-perc (if (pos? total-count) (int (* (/ unfinished-nonexception-count total-count) 100)) 0)
        exception-messages
        #{"Read timed out", "Network is unreachable (connect failed)"}
        exception-count
        (count
          (filter
            (fn [log]
              (and
                (= (:status log) "Exception")
                (not (contains? exception-messages (:message log)))))
            actual-logs))
        exception-perc (if (pos? actual-count) (int (* (/ exception-count actual-count) 100)) 0)
        network-failed-count
        (count
          (filter
            (fn [log]
              (and
                (= (:status log) "Exception")
                (contains? exception-messages (:message log))))
            actual-logs))
        network-failed-countperc (if (pos? actual-count) (int (* (/ network-failed-count actual-count) 100)) 0)]
    {:expected-count total-count :actual-count actual-count
     :started-count started-count :finished-count finished-count
     :unfinished-count unfinished-count
     :nomsgfin-count nomsgfin-count
     :network-failed-count network-failed-count :network-failed-countperc network-failed-countperc
     :unfinished-nonexception-count-perc unfinished-nonexception-count-perc
     :missing-count missing-count :missing-perc missing-perc
     :cancelled-count cancelled-count :cancelled-perc cancelled-perc
     :skipped-count skipped-count :skipped-perc skipped-perc
     :misfire-count misfire-count :misfire-perc misfire-perc
     :exception-count exception-count :exception-perc exception-perc
     :max-time max-time :min-time min-time :avg-time avg-time
     :first-missing (table-cell-to-date (:datescheduled (first sorted-missed-logs)) "dd/MM/yyyy HH:mm:ss")
     :last-missing (table-cell-to-date (:datescheduled (last sorted-missed-logs)) "dd/MM/yyyy HH:mm:ss")}))

(defn reconcile-cron-firings [expected-firings cron-logs]
  (let [idx-cron-logs (u/index-by :datescheduled cron-logs)]
    (reduce
      (fn [acc expected-firing]
        (let [expected-scheduled-time (:scheduled-time expected-firing)
              expected-unixtime (ud/php-timestamp expected-scheduled-time)
              next-fire-time (:next-scheduled-time expected-firing)
              next-fire-unixtime (ud/php-timestamp next-fire-time)
              log (get idx-cron-logs expected-scheduled-time)
              misfire-log
              (filter
                (fn [cron-log]
                  (let [datescheduled-unixtime (ud/php-timestamp (:datescheduled cron-log))]
                    (and
                      (> datescheduled-unixtime expected-unixtime)
                      (< datescheduled-unixtime next-fire-unixtime))))
                (vals idx-cron-logs))]
          (conj acc
            (cond
              (and
                (nil? log)
                (empty? misfire-log))
              {:status "Missed"
               :message ""
               :datestarted nil
               :datefinished nil
               :datescheduled expected-scheduled-time
               :datedscheduled-unixtime expected-unixtime}

              (not (empty? misfire-log))
              (assoc
                (first misfire-log)
                :status "Misfire"
                :datedscheduled-unixtime expected-unixtime)

              :else
              (assoc log
                :datedscheduled-unixtime expected-unixtime)))))
      [] expected-firings)))

(defn cron-log-metadata [{:keys [expected-firings cron-logs]}]
  (let [now (dt/now)
        now-unixtime (ud/php-timestamp now)
        ;; When we have expected-firings, reconcile them with actual logs
        ;; When we don't (no cron expression), just use raw cron-logs with unixtime added
        base-logs
        (cond
          (not (empty? expected-firings))
          (reconcile-cron-firings expected-firings cron-logs)

          :else
          (map
            (fn [log]
              (assoc log :datedscheduled-unixtime (ud/php-timestamp (:datescheduled log))))
            cron-logs))
        current-logs
        (remove
          (fn [cron-log]
            (> (:datedscheduled-unixtime cron-log) now-unixtime))
          base-logs)
        logs (sort-by :datedscheduled-unixtime u/desc current-logs)
        summary (cron-summary-data current-logs)]
    {:cron/summary summary
     :cron/logs logs
     :cron/scheduled-to now}))

;; ============================================================================
;; Unified Dashboard Table Cell Renderers
;; ============================================================================

(defn exceptions-cell [app-atom row col v]
  [:span
   {:style {:color (if (and v (> v 0)) "#c0392b" "inherit")
            :font-weight (if (and v (> v 0)) "bold" "normal")}}
   (or v 0)])

(defn misfires-cell [app-atom row col v]
  [:span
   {:style {:color (if (and v (> v 5)) "#d35400" "inherit")
            :font-weight (if (and v (> v 5)) "bold" "normal")}}
   (or v 0)])

(defn avg-time-cell [app-atom row col v]
  [:span
   (cond
     (nil? v) "N/A"
     :else (str (.toFixed v 1) "s"))])

(defn job-name-link [app-atom row col v]
  [:a
   (urlstate/href-props app-atom "cronscheduler" "overview" {:job-name v})
   [:span {:style {:cursor "pointer"}} v]])

(defn status-cell [app-atom row col v]
  (let [{:cron/keys [firing-state]} row
        running? (some? firing-state)]
    [:span
     {:style {:display "flex" :align-items "center" :gap "4px"}}
     [:span
      {:style {:background-color (if (= v "Active") "#90EE90" "#ccc")
               :padding "2px 8px"
               :border-radius "4px"
               :font-size "12px"}}
      v]
     (when running?
       [:span
        {:style {:background-color "#87ceeb"
                 :padding "2px 6px"
                 :border-radius "4px"
                 :font-size "11px"
                 :animation "pulse 1.5s infinite"}}
        "Running"])]))

(defn status-filter-logic [_app-atom row _col v]
  (let [{:cron/keys [firing-state]} row
        running? (some? firing-state)]
    (if running?
      (str v " Running")
      v)))

(defn next-fire-cell [app-atom row col v]
  [:span
   (cond
     (some? v)
     (ud/format-date v "dd MMM HH:mm")
     :else "N/A")])

(defn elapsed-cell [app-atom row col v]
  (let [{:cron/keys [elapsed-seconds firing-state]} row]
    [:span
     (cond
       (and (some? firing-state) (some? elapsed-seconds))
       (str elapsed-seconds "s")
       :else "-")]))

(def unified-table-fns
  {:column-fns
   {:job-name-link job-name-link
    :status-cell status-cell
    :status-filter-logic status-filter-logic
    :exceptions-cell exceptions-cell
    :misfires-cell misfires-cell
    :next-fire-cell next-fire-cell
    :elapsed-cell elapsed-cell}})

(def unified-dashboard-columns
  [{:key :cron/job-name
    :title "Job Name"
    :render {:render-k :job-name-link}}
   {:key :cron/status
    :title "Status"
    :align-class :u-text-center
    :render {:render-k :status-cell
             :logic-k :status-filter-logic}}
   {:key :cron/exceptions-24h
    :title "Exc (24h)"
    :align-class :u-text-center
    :render {:render-k :exceptions-cell}}
   {:key :cron/misfires-24h
    :title "Mis (24h)"
    :align-class :u-text-center
    :render {:render-k :misfires-cell}}
   {:key :cron/finished-24h
    :title "Fin (24h)"
    :align-class :u-text-center}
   {:key :cron/next-fire-time
    :title "Next Fire"
    :align-class :u-text-center
    :render {:render-k :next-fire-cell}}
   {:key :cron/elapsed-seconds
    :title "Elapsed"
    :align-class :u-text-center
    :render {:render-k :elapsed-cell}}
   {:key :cron/expression
    :title "Expression"}])

(def unified-dashboard-table-config
  {:table-name :admin.cronscheduler/unified-dashboard
   :row-id :cron/job-name
   :options
   {:order :asc
    :sticky-header? true
    :paging? true
    :pagination {:page 0 :page-size 20}}
   :data-source
   {:cursor [:admin.cronscheduler :unified-dashboard]
    :schema :admin.cronscheduler/schema}
   :column-defs unified-dashboard-columns})

(defmethod comms/receive :admin.cronscheduler/cron.log [app-atom {:keys [cron]}]
  (let [process-atom (cmn/process-cursor app-atom)
        cron-health
        (assoc (cron-log-metadata cron)
          :cron/scheduled-from (:scheduled-from cron))]
    (toaster/close-overlay app-atom :admin.cronscheduler/cron-log)
    (swap! process-atom update :crons
      (fn [crons]
        (assoc-in crons [(:job-name cron) :cron/health] cron-health)))))

(defmethod grid/action :admin.cronscheduler/open-cron-log [app-atom {:cron/keys [job-name expression]} _]
  (toaster/open-overlay app-atom :admin.cronscheduler/cron-log)
  (toaster/open-overlay app-atom :admin.cronscheduler/cron-trend)
  (grid/open-modal app-atom :admin.cronscheduler/cron-log {:cron/job-name job-name})
  (comms/send :admin.cronscheduler/cron.log {:cron/job-name job-name :cron/expression expression})
  (comms/send :admin.cronscheduler/cron.trend {:cron/job-name job-name}))

(defmethod comms/receive :admin.cronscheduler/cron.job-data [app-atom {:keys [cron]}]
  (let [process-atom (cmn/process-cursor app-atom)
        editor-atom (editor/editor-cursor app-atom :cron-executor)]
    (toaster/close-overlay app-atom :admin.cronscheduler/cron-job)
    (swap! process-atom update :crons
      (fn [crons]
        (assoc-in crons [(:cron/job-name cron) :cron/inputs] (:cron/inputs cron))))
    (swap! editor-atom dissoc :form)
    (grid/open-modal app-atom :admin.cronscheduler/cron-job
      {:cron/job-name (:cron/job-name cron)
       :cron/inputs (:cron/inputs cron)})))

(defmethod grid/action :admin.cronscheduler/open-cron-job [app-atom {:cron/keys [job-name]} _]
  (let [process-atom (cmn/process-cursor app-atom)
        cron (cmn/curact process-atom [:crons job-name])
        editor-atom (editor/editor-cursor app-atom :cron-executor)]
    (cond
      (nil? (:cron/inputs cron))
      (do
        (toaster/open-overlay app-atom :admin.cronscheduler/cron-job)
        (comms/send :admin.cronscheduler/cron.job-data
          {:cron/job-name job-name
           :cron/job-group (:cron/job-group cron)}))

      :else
      (do
        (swap! editor-atom dissoc :form)
        (grid/open-modal app-atom :admin.cronscheduler/cron-job
          {:cron/job-name job-name
           :cron/inputs (:cron/inputs cron)})))))

(def default-firing-update-value -1)

(defn toggle-status-filter [filters-atom status]
  (let [current-filter (get @filters-atom "Status" "")
        current-statuses (if (empty? current-filter)
                          #{}
                          (set (str/split current-filter #"\|")))
        new-statuses (if (contains? current-statuses status)
                      (disj current-statuses status)
                      (conj current-statuses status))
        new-filter (str/join "|" (sort new-statuses))]
    (if (empty? new-statuses)
      (swap! filters-atom dissoc "Status")
      (swap! filters-atom assoc "Status" new-filter))))

(defn toggle-numeric-filter
  "Toggle a numeric filter (e.g., >0 for exceptions/misfires)"
  [filters-atom column-name operator value]
  (let [filter-value (str operator value)
        current-filter (get @filters-atom column-name "")]
    (if (= current-filter filter-value)
      (swap! filters-atom dissoc column-name)
      (swap! filters-atom assoc column-name filter-value))))

(rum/defc status-badge < rum/reactive cmn/cursors
  [filters-atom status-value label bg-color]
  (let [current-filter (rum/react (rum/cursor filters-atom "Status"))
        current-statuses (if (or (nil? current-filter) (empty? current-filter))
                          #{}
                          (set (str/split current-filter #"\|")))
        is-selected? (contains? current-statuses status-value)
        opacity (if (or (empty? current-statuses) is-selected?) "1" "0.3")]
    [:span
     {:style {:margin-right "16px" :cursor "pointer"}
      :on-click #(toggle-status-filter filters-atom status-value)}
     [:span
      {:style {:background-color bg-color
               :padding "2px 8px"
               :border-radius "4px"
               :font-size "12px"
               :opacity opacity
               :border (if is-selected? "2px solid #333" "2px solid transparent")
               :font-weight (if is-selected? "bold" "normal")}}
      label]]))

(rum/defc numeric-badge < rum/reactive cmn/cursors
  [filters-atom column-name operator value label bg-color]
  (let [filter-value (str operator value)
        current-filter (rum/react (rum/cursor filters-atom column-name))
        is-selected? (= current-filter filter-value)]
    [:span
     {:style {:margin-right "16px" :cursor "pointer"}
      :on-click #(toggle-numeric-filter filters-atom column-name operator value)}
     [:span
      {:style {:background-color bg-color
               :padding "2px 8px"
               :border-radius "4px"
               :font-size "12px"
               :opacity (if is-selected? "1" "0.3")
               :border (if is-selected? "2px solid #333" "2px solid transparent")
               :font-weight (if is-selected? "bold" "normal")}}
      label]]))

(defmethod grid/action :admin.cronscheduler/ping-unified-dashboard [app-atom {:keys [value]} _]
  (let [seconds-timeout (int (or value default-firing-update-value))]
    (u/timeout (* seconds-timeout 1000)
      #(comms/send :admin.cronscheduler/unified.dashboard {}))))

(rum/defc cron-scheduler-dashboard < rum/reactive cmn/cursors [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        table-atom (datatables/table-cursor app-atom :admin.cronscheduler/unified-dashboard)
        config-atom (rum/cursor table-atom :config)
        options-atom (rum/cursor config-atom :options)
        filters-atom (rum/cursor options-atom :filters)
        ;; Check if table is initialized to prevent errors on initial render
        table-initialized? (some? (rum/react config-atom))]
    [:div
     [:div
      {:class (u/bem :flex-grid-group [:flush-force :align-left :valign-middle])}
      [:div
       (headings/heading "Cron Scheduler Dashboard" {:type :h1 :size :large})
       (headings/heading "Where the things thing all the time..." {:size :medium})]
      [:div
       {:style {:margin-left "auto"}}
       (forms/select
         "Auto-refresh:" (rum/cursor process-atom :firing-ping)
         [{:value -1 :text "Disabled"}
          {:value 5 :text "5 seconds"}
          {:value 10 :text "10 seconds"}
          {:value 15 :text "15 seconds"}
          {:value 30 :text "30 seconds"}]
         {:small? true
          :default default-firing-update-value
          :change-fn
          (fn [_ v]
            (when (pos? v)
              (grid/dispatch-action app-atom :admin.cronscheduler/ping-unified-dashboard {:value v})))})]]

     ;; Status Legend with clickable filters - only show when table is initialized
     (when table-initialized?
       [:div
        {:style {:margin-bottom "12px"}}
        [:span {:style {:margin-right "8px" :font-weight "bold"}} "Quick Filters:"]
        (status-badge filters-atom "Active" "Active" "#90EE90")
        (status-badge filters-atom "Inactive" "Inactive" "#ccc")
        (status-badge filters-atom "Running" "Running" "#87ceeb")
        [:span {:style {:margin-right "16px" :color "#999"}} "|"]
        (numeric-badge filters-atom "Exc (24h)" ">" 0 "Exceptions" "#f18d8b")
        (numeric-badge filters-atom "Mis (24h)" ">" 5 "Misfires (>5)" "#ffda6a")
        [:span {:style {:margin-right "16px" :color "#999"}} "|"]
        (numeric-badge filters-atom "Fin (24h)" "=" 0 "No Recent Runs" "#e67e22")
        (numeric-badge filters-atom "Elapsed" ">" 300 "Long Running (>5m)" "#3498db")])

     ;; Unified Dashboard Table
     [:div.u-relative
      (datatables/table app-atom :admin.cronscheduler/unified-dashboard unified-table-fns)
      (toaster/loading-overlay app-atom :admin.cronscheduler/dashboard)]]))

(defmethod flow/render-screen :admin.cronscheduler [app-atom _]
  (cron-scheduler-dashboard app-atom))

(defmethod t/transition-open :admin.cronscheduler [app-atom _ _]
  (toaster/open-overlay app-atom :admin.cronscheduler/dashboard)
  (comms/send :admin.cronscheduler/unified.dashboard {}))

(defmethod t/transition-after-open :admin.cronscheduler [app-atom _ _]
  (dcommon/kill-search-bar)
  (presence/open app-atom {:context/ident :admin.cronscheduler})
  (datatables/initiate app-atom unified-dashboard-table-config {}))

(defmethod comms/receive :admin.cronscheduler/unified.dashboard [app-atom {:keys [dashboard]}]
  (let [process-atom (cmn/process-cursor app-atom)
        firing-ping-atom (rum/cursor process-atom :firing-ping)
        firing-ping (or @firing-ping-atom default-firing-update-value)]
    (toaster/close-overlay app-atom :admin.cronscheduler/dashboard)
    (swap! process-atom assoc
      :unified-dashboard (u/index-by :cron/job-name dashboard)
      ;; Also populate crons for backwards compatibility with existing modals
      :crons (u/index-by :cron/job-name dashboard))
    ;; Continue auto-refresh if enabled
    (when (pos? firing-ping)
      (grid/dispatch-action app-atom :admin.cronscheduler/ping-unified-dashboard {:value firing-ping}))))

(defmethod comms/receive :admin.cronscheduler/cron.trend [app-atom {:keys [trend]}]
  (let [process-atom (cmn/process-cursor app-atom)
        job-name (:job-name trend)]
    (toaster/close-overlay app-atom :admin.cronscheduler/cron-trend)
    (swap! process-atom assoc-in [:crons job-name :cron/trend] (:data trend))))